import { render, staticRenderFns } from "./StateIncomeTaxReturn.vue?vue&type=template&id=78b7f4a5&scoped=true&"
import script from "./StateIncomeTaxReturn.vue?vue&type=script&lang=ts&"
export * from "./StateIncomeTaxReturn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b7f4a5",
  null
  
)

export default component.exports